import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-zinc-900 bg-[#09090B] mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-[#C0A062]" />
            <span className="font-bold text-white tracking-wider">
              DOJO<span className="text-[#C0A062]">DASH</span>
            </span>
          </div>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
            <Link to="/about" className="text-zinc-400 hover:text-white" data-testid="footer-about-link">
              About
            </Link>
            <Link to="/trainers" className="text-zinc-400 hover:text-white" data-testid="footer-trainers-link">
              Find a trainer
            </Link>
            <Link to="/terms" className="text-zinc-400 hover:text-white" data-testid="footer-terms-link">
              Terms
            </Link>
            <Link to="/privacy" className="text-zinc-400 hover:text-white" data-testid="footer-privacy-link">
              Privacy
            </Link>
          </nav>

          <p className="text-xs text-zinc-600">© {year} DojoDash. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
